<template>
  <div class="box">
    <dv-scroll-board :config="config" class="table" />
  </div>
</template>

<script>
import Api from '@/api'
import { dateFormat } from '@/utils/tools'

export default {
  data() {
    return {
      Timer: null,
      config: {},
      data: []
    }
  },
  created() {
    // 2分钟刷新一次数据
    this.initData()
    this.Timer = setInterval(() => {
      this.initData()
    }, 120000)
  },
  watch: {
    selfAreaId(v, o) {
      this.initData()
    },
    abnormalType(v) {
      this.initData()
    }
  },
  props: {
    abnormalType: {
      default: null,
      type: [String, Number]
    },
    selfAreaId: {
      default: '',
      type: String
    }
  },
  methods: {
    initData() {
      if (!this.selfAreaId) {
        this.config = {
          columnWidth: [80, 120, 80, 150],
          data: []
        }
        return
      }
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId,
        currentPage: 1,
        pageSize: 1000
      }
      if (vm.abnormalType === 1 || vm.abnormalType === 7 || vm.abnormalType === 13) {
        params.abnormalType = vm.abnormalType
      }
      // params = getFilterParams(params)
      Api.getMsg(params).then((res) => {
        if (res.code === 200) {
          // vm.abnormalData = res.data.lists;
          let arr = res.data.lists.filter((val) => {
            return ['1', '4', '6', '7', '13'].includes(val.abnormalType)
          })
          arr = arr.slice(0, 10)
          vm.data = arr.map((val) => {
            return [
              val.brandName,
              this.getShowText(val),
              `<span style="color:#00DADA;">${this.getAbnormalType(
                val.abnormalType
              )}</span>`,
              // eslint-disable-next-line quotes
              dateFormat(val.updateTime, "yyyy-MM-dd hh:mm")
            ]
          })
          vm.config = {
            columnWidth: [80, 120, 80, 150],
            data: vm.data
          }
        } else {
          console.log('获取异常告警数据为空')
        }
      })
    },
    getAbnormalType(type) {
      return {
        1: '站外还车',
        2: '违法设备',
        3: '超时未还',
        4: '异常站点',
        5: '故障车辆',
        6: '满桩还车',
        7: '非法车辆',
        8: '不可投放站点上架',
        9: '还车异常',
        10: '租车异常',
        11: '上架异常',
        12: '下架异常',
        13: '站外投车'
      }[String(type)]
    },
    getShowText(item) {
      let str = ''
      if (item.siteName) {
        str = item.siteName
      } else if (item.lon && item.lat) {
        str = `经度：${item.lon}，纬度：${item.lat}`
      } else {
        str = ''
      }
      return str
    }
  },
  beforeDestroy() {
    if (this.Timer) {
      clearInterval(this.Timer)
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  padding: 0 16px;
  .table {
    flex: 1;
    width: 100%;
  }
}
</style>
<style lang="less">
.row-item {
  background: transparent !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
</style>
